import { Injectable } from '@angular/core';
import { PropertiesService } from './properties.service';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import {ActionsService} from "@shared/services/web/actions.service";

@Injectable({
  providedIn: 'root',
})
export class CaptacionRegistroService {
  email: string;
  cookieHsUtk: string;

  constructor(
    private propertiesService: PropertiesService,
    private cookieService: CookieService,
    private actionsService: ActionsService
  ) {
    this.cookieHsUtk = this.cookieService.get('hubspotutk');
  }

  verifyUser() {
    this.propertiesService.getEmail(this.email).subscribe((resp) => {
      if (Object.keys(resp).length === 0) {
        const newPassword = this.randomPassword(10);
        const registerObj = {
          email: this.email,
          password: newPassword,
          repeat_password: newPassword,
          receiveNotifications: true,
          receiveNotificationsContent: true,
          receiveNotificationsProcesses: true,
          receiveNotificationsCommercial: true,
          cookieHsUtk: this.cookieHsUtk,
        };
        this.propertiesService
          .registerEmail(registerObj, true)
          .subscribe(() => {
            this.actionsService.sentEmail(true);
          });
      } else {
        if (!resp.verified) {
          const emailUser = {
            email: this.email,
          };
          this.propertiesService.SendEmail(emailUser).subscribe(
            (res) => {
              this.actionsService.sentEmail(true);
            },
            (error) => {}
          );
        }
      }
    });
  }

  verifyUserObservable(): Observable<any> {
    return this.propertiesService.getEmail(this.email);
  }

  sendEmail(email: string) {
    this.email = email;
  }

  randomPassword(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result + 'i24';
  }
}
